import { Dispatch, SetStateAction } from 'react';

import Close from '../../../assets/Close.svg';
import { Container } from './styles';

interface IFilterSelectDropdownProps {
  title: string;
  value: string;
  onChange: Dispatch<SetStateAction<string>>;
  options: Array<{ value: string; label: string }>;
  disabled?: boolean;
}

const FilterSelectDropdown = ({
  title,
  value,
  onChange,
  options,
  disabled = false,
}: IFilterSelectDropdownProps) => {
  const cleanInputsAction = () => {
    onChange('');
  };

  return (
    <Container>
      <label>{title}</label>
      <div className="container-filter-input">
        <select
          className="form-control"
          value={value}
          onChange={e => onChange(e.target.value)}
          disabled={disabled}
        >
          <option value="">Selecione...</option>
          {options.map(option => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
        <img onClick={cleanInputsAction} src={Close} alt="Limpar" />
      </div>
    </Container>
  );
};

export { FilterSelectDropdown };
